import React from "react";
import { UnaryFn } from "@tvg/ts-types/Functional";
import { TopPool } from "@tvg/ts-types/Pool";
import { LinkItem } from "@tvg/design-system";
import MtpValue from "../MtpValue";
import { QA_LABEL } from "../../qaLabels";
import AmountValue from "../AmountValue";

export const renderPoolsArray = (
  vec: TopPool[],
  onPoolClick: UnaryFn<TopPool, void>
) =>
  vec.map((pool, index) => (
    <LinkItem
      key={
        pool.trackCode +
        pool.race.raceNumber +
        pool.race.postTime +
        index.toString()
      }
      start={<MtpValue race={pool.race} />}
      end={<AmountValue amount={pool.amount} />}
      title={{
        render: pool.track
      }}
      description={pool.wagerType.name}
      onPress={() => onPoolClick(pool)}
      qaLabel={QA_LABEL.body.desktop.pool}
      hasArrowRight={false}
    />
  ));
